<template>
    <div class="footer" :class="{ footer: true, big: big }">
        <div class="center">
            <div class="right-column">
                <p class="quick-link" style="margin-bottom:15px">
                    <!-- <a href="https://www.heiyan.com/about/declare">构建绿色阅读平台倡议书</a> -->
                    <a href="https://www.heiyan.com/about/about">关于黑岩</a>
                    <!-- <a href="https://www.heiyan.com/about/award">奖励计划</a> -->
                    <a href="https://www.heiyan.com/about/contact">联系我们</a>
                    <!-- <a href="https://book.heiyan.com/book/add">成为作者</a> -->
                </p>
                <p class="kfu">
                    <span>客服邮箱：<a href="mailto:kefu@heiyan.com" ref="external nofollow"
                            class="button-link">kefu@heiyan.com</a></span>
                    <span>QQ：2984543729 2814551419</span>
                </p>
                <p class="kfu">
                    <span>不良信息举报：<a href="mailto:jubao@heiyan.com" ref="external nofollow"
                            class="button-link">jubao@heiyan.com</a></span>
                    <span>电话：010-82156292</span>
                </p>
                <p class="beian">
                    <a href="https://b-new.heiyanimg.com/img/ICP.jpg" target="_blank">京ICP证140449号</a>
                    <a href="https://beian.miit.gov.cn/" ref="external nofollow" target="_blank">京ICP备13019311号-1</a>
                </p>
                <p>
                    <a class="licence" style="" href="https://b-new.heiyanimg.com/img/20190215182445.jpg"
                        ref="external nofollow" target="_blank">出版物经营许可证 </a> 新出发京零字第朝 210455号
                </p>
                <p>
                    <a class="licence-con" style="" href="https://b-new.heiyanimg.com/img/20190215182458.jpg"
                        ref="external nofollow" target="_blank">网络文化经营许可证</a> 京网文（2024） 3232-160号
                </p>
                <p>Copyright © 2014 Heiyan.com All rights reserved.</p>
                <p>
                    <a target="_blank" ref="external nofollow"
                        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802028299">
                        京公网安备 11010802028299号
                    </a>
                </p>
                <div class="address-box">
                    <p><a href="https://b-new.heiyanimg.com/img/1522047498121_1743309735.jpg" ref="external nofollow"
                            target="_blank">北京黑岩信息技术有限公司</a>地址：北京市朝阳区紫月路18号院4号楼五层508</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            big: Boolean
        },
        data() {
            return {
            };
        },

    }
</script>

<style lang="scss">
    .footer {
        width: 100%;
        height: 336px;
        background: #033146;
        // background: url(../assets/head/body-bg-repeat.png);

        .center {
            margin: 0 auto;
            width: 1400px;
            height: 336px;
            background: url(../../assets/logo1.png) no-repeat 10px 17px;
            background-size: 100px 95px;

            .right-column {
                padding: 34px 30px 0 0;
                float: right;
                text-align: right;

                p {
                    color: #666;
                    font-size: 12px;
                    margin-bottom: 10px;

                    a {
                        color: #666;
                        margin-right: 6px;
                    }

                    .button-link {
                        color: #F68A01;
                    }
                }

                .quick-link {
                    a {
                        color: #999;
                    }
                }
            }
        }
    }
</style>
